import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router'
import { useMemo } from 'react'
import { ReportBuilderPage } from '@/features/city-clerk/admin-report'
import { createHeavyReportConfig } from '@/features/city-clerk/admin-report/builder/configs/createHeavyReportConfig'
import { useNavigation } from '@/utils/navigation'

export const Route = createFileRoute(
  '/(app)/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/heavy-report/$templateKey/',
)({
  beforeLoad: ({ context }) => {
    if (context.auth.loading) return
    if (!context.auth.userInfo?.uiCapabilities?.adminReportView) {
      throw redirect({ to: '/access-denied' })
    }
  },
  component: RouteComponent,
})

function RouteComponent() {
  const {
    id: cityId,
    projectId,
    permitId,
    permitSubmitalId,
    templateKey,
  } = Route.useParams()
  const navigate = useNavigate()
  const nav = useNavigation(navigate)

  const config = useMemo(
    () => createHeavyReportConfig(permitId, permitSubmitalId, templateKey),
    [permitId, permitSubmitalId, templateKey],
  )

  function onBack() {
    nav.toHeavyReport(cityId, projectId, permitId, permitSubmitalId)
  }

  return <ReportBuilderPage config={config} onBack={onBack} />
}
